/* eslint-disable import/no-import-module-exports */
import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import { createReduxHistoryContext } from 'redux-first-history';

import { LOGOUT } from './actionConstants';

import { localStorageMiddleware, promiseMiddleware } from './middleware';
import createRootReducer from './reducers';

export const { createReduxHistory, routerMiddleware, routerReducer } =
  createReduxHistoryContext({
    history: createBrowserHistory(),
  });

const logoutEnhancer = (rootReducer) => (state, action) => {
  if (action.type !== LOGOUT) return rootReducer(state, action);
  const newState = rootReducer(undefined, action);
  newState.router = state.router;
  return newState;
};

const composeEnhancers =
  (process.env.NODE_ENV !== 'production' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

export const store = createStore(
  logoutEnhancer(createRootReducer()),
  compose(
    composeEnhancers(
      applyMiddleware(
        routerMiddleware,
        promiseMiddleware,
        localStorageMiddleware,
      ),
    ),
  ),
);

export const history = createReduxHistory(store);

if (module.hot) {
  // Enable Webpack hot module replacement for reducers
  module.hot.accept('./reducers', () => {
    const nextCreateRootReducer = require('./reducers').default;
    store.replaceReducer(nextCreateRootReducer(history));
  });
}
